import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class TopbarComponent {
  @Input() isSidebarOpen: boolean = false;
  @Input() hasShadow: boolean = false;
  /** Active view mode — drives the prominent header title. */
  @Input() appMode: 'standard' | 'code' | 'writing' | 'image' = 'standard';
  @Output() toggleSidebar = new EventEmitter<void>();
  @Output() newChat = new EventEmitter<void>();

  isDropdownVisible = false;

  /** Prominent name shown in the header for the current mode. */
  get modeTitle(): string {
    switch (this.appMode) {
      case 'code': return 'Code';
      case 'writing': return 'Writing';
      default: return '';
    }
  }

  /** Short descriptor shown under the mode title. */
  get modeSubtitle(): string {
    switch (this.appMode) {
      case 'code': return 'Ask questions, debug, or generate code';
      case 'writing': return 'Review, rewrite, or draft content to FI style';
      default: return '';
    }
  }
}